// extracted by mini-css-extract-plugin
module.exports = {"button":"copy-to-clipboard_button_3L2qL","icon":"copy-to-clipboard_icon_2eR_H"};